import { AlertTriangle } from 'lucide-react'

interface ErrorStateProps {
  message: string
  onRetry?: () => void
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <AlertTriangle size={48} className="text-red-400 mb-4" />
      <p className="text-gray-700 mb-4">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn btn-secondary">
          Reintentar
        </button>
      )}
    </div>
  )
}
